import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.PROVIDER,
  primaryKey: 'id',
  properties: {
    id: 'int',
    name: 'string',
    phone: 'string?',
    address: 'string?',
    email: 'string?',
    note: 'string?',
    icon: 'string?',
    orders: `${DataConst.MODELS.IMPORT_ORDER}[]`,
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
